<template>
    <Dialog :draggable="false" v-model:visible="props.visible" @update:visible="emit('close')" modal :dismissableMask="true"  :style="{ width: '500px' }" :breakpoints="{ '576px': '90vw' }" 
    :pt="{ header: { class:'d-flex justify-content-end pt-2 pe-md-2' } }">
        <div class="avatar avatar-icon bg-primary-100 large-size mx-auto mb-4">
            <i class="material-symbols-rounded fsz-24 me-0 text-primary-600">mobile_2</i>
        </div>
        <h5 class="text-center fw-semiBold mb-4">Application en cours de développement</h5>
        <p class="fsz-14 text-center text-gray-700 mb-4">
            Nos applications mobiles iOS et Android sont actuellement en cours de développement.
        </p>
        <p class="fsz-14 text-center text-gray-700 mb-20">
            Restez connectés, elles seront bientôt disponibles pour une expérience encore plus fluide et pratique sur mobile !
        </p>
        <template #footer>
            <div class="d-flex flex-row-reverse  gap-2">
                <button @click="emit('confirm')" class="btn xsmall-btn btn-solid-primary-600 disabled-pointer d-flex align-items-center gap-1">
                        <i class="material-symbols-rounded fsz-16">check</i> 
                        Fermer
                </button>
            </div>
             
        </template>
        
    </Dialog>
  </template>
  
  <script setup lang="ts">  
  
  const props = defineProps({
    visible: {
      type: Boolean,
      required: true,
    },
  });
  
  const emit = defineEmits(['close', 'confirm']);

</script>
  
<style lang="scss">
.large-size {
    width: 60px;
    height: 60px;
}
</style>